import { render, staticRenderFns } from "./leftSubMenuV2.vue?vue&type=template&id=3c5d275d&scoped=true"
import script from "./leftSubMenuV2.vue?vue&type=script&lang=js"
export * from "./leftSubMenuV2.vue?vue&type=script&lang=js"
import style0 from "./leftSubMenuV2.vue?vue&type=style&index=0&id=3c5d275d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d275d",
  null
  
)

export default component.exports